import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.textBackground.light,
    marginBottom: theme.spacing(14),
  },
  section: {
    width: '100%',
    paddingTop: theme.spacing(1),
    marginBottom: theme.spacing(-2),
  },
  rightContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
}))
